module.exports = __webpack_public_path__ + "media/images/lp/icn_tel_02-141e96466b4e2854b3110ce36f903a1c.svg";